import { render, staticRenderFns } from "./grafico-barra-new-ux.vue?vue&type=template&id=305e23d3&"
import script from "./grafico-barra-new-ux.vue?vue&type=script&lang=js&"
export * from "./grafico-barra-new-ux.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('305e23d3')) {
      api.createRecord('305e23d3', component.options)
    } else {
      api.reload('305e23d3', component.options)
    }
    module.hot.accept("./grafico-barra-new-ux.vue?vue&type=template&id=305e23d3&", function () {
      api.rerender('305e23d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/grafico-barra-new-ux.vue"
export default component.exports